import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Teaching from 'components/BKantarciTeaching/Teaching';

function KanatrciTeaching() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Teaching/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Teaching/>
        <Footer />
      </>
    )}
    </>
  );
}

export default KanatrciTeaching;
